import script from "./songclass.vue?vue&type=script&setup=true&lang=js"
export * from "./songclass.vue?vue&type=script&setup=true&lang=js"

import "./songclass.vue?vue&type=style&index=0&id=d328b22c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d328b22c"]])

export default __exports__